module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/Dec18_Broadway_Clark_CR-p-800-d24ff0fe70dce1b13a0003f85bac7e98.jpg";